export default "__VITE_ASSET__2a1dc0d7__"